import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const useCases = [
  "Music Festivals",
  "Rooftop Bars",
  "Pop-up Retail",
  "Luxury Hotels"
];

export default function HeroInteractive() {
  const [currentUseCase, setCurrentUseCase] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentUseCase((prev) => (prev + 1) % useCases.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full flex flex-col items-center justify-center overflow-hidden bg-white pt-4 sm:pt-8 md:pt-12 pb-16 sm:pb-20 md:pb-24 border-b border-gray-100">
      
      {/* Container - Strictly bounded, zero overlap potential */}
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 text-center flex flex-col items-center">
        
        {/* Natural Logo Integration */}
        {/* Because the page is bg-white, the logo's white background is perfectly invisible natively. No hacks. */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="mb-6 sm:mb-8 md:mb-12 flex justify-center w-full"
        >
          <img 
            src="/tapn-logo.png" 
            alt="Tapn" 
            className="h-48 sm:h-72 md:h-96 lg:h-[36rem] xl:h-[48rem] w-auto max-w-full object-contain" 
          />
        </motion.div>

        {/* Dynamic Typography - Deep Charcoal for Light Theme */}
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
          className="text-3xl sm:text-5xl md:text-7xl lg:text-8xl font-black tracking-tight text-[#0A0A0A] mb-4 sm:mb-6 md:mb-8 leading-[1.1]"
        >
          Payments for <br />
          <span className="relative inline-block h-[1.2em] w-full max-w-[280px] sm:max-w-[420px] md:max-w-[600px] overflow-hidden align-bottom">
            <AnimatePresence mode="wait">
              <motion.span
                key={currentUseCase}
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -50, opacity: 0 }}
                transition={{ duration: 0.5, ease: "anticipate" }}
                className="absolute inset-0 bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 to-teal-500"
              >
                {useCases[currentUseCase]}
              </motion.span>
            </AnimatePresence>
          </span>
        </motion.h1>

        <motion.p 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.4 }}
          className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-500 max-w-2xl mx-auto mb-8 sm:mb-10 md:mb-12 font-medium px-2"
        >
          No hardware. No queues. Just seamless tap-to-pay infrastructure turning any smartphone into a point of sale.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center w-full max-w-md sm:max-w-none"
        >
          <a href="https://paygent.transactiongateway.com" className="px-6 sm:px-8 py-3.5 sm:py-4 rounded-xl bg-[#0A0A0A] text-white font-bold text-base sm:text-lg hover:bg-gray-800 active:scale-[0.98] transition-all shadow-xl cursor-pointer inline-block text-center">
            Deploy Tapn
          </a>
          <a href="/resources/case-studies" className="px-6 sm:px-8 py-3.5 sm:py-4 rounded-xl bg-white text-[#0A0A0A] border border-gray-200 font-bold text-base sm:text-lg hover:bg-gray-50 active:scale-[0.98] transition-all cursor-pointer inline-block text-center">
            View Case Studies
          </a>
        </motion.div>

      </div>
    </section>
  );
}
